// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__3Wm3u","modal":"Modal_modal__1vwov","content":"Modal_content__BZbGL","close":"Modal_close__2EfR5"};